/**
 * [Impure] Set value in nested object structure.
 * @param obj - Root object.
 * @param key - "." separated key string.
 * @param value - Value to be set.
 */
export function deepSet(obj: any, key: string, value: any) {
    const keySplit = key.split(".");
    let target = obj;
    keySplit.forEach((prop, i) => {
        if (i === key.split.length - 1) return target[prop] = value;
        if (target[prop] === undefined) target[prop] = {};
        target = target[prop];
    });
}
